<div class="parameter-value">
  @if ((!isEdit() && showEditButton()) || !isEditable()) {
    <div class="parameter-value__view">
      <span
        class="parameter-value__text"
        [textContent]="displayText()"
        [matTooltip]="readOnlyFormat()"
        [matTooltipDisabled]="!shouldShowTooltip()"
      ></span>
      @if (isEditable()) {
        <button mat-icon-button color="accent" (click)="onClickEdit()">
          <mat-icon>edit</mat-icon>
        </button>
      }
    </div>
  } @else {
    <div class="parameter-value__edit">
      @if (valueType() === 'ENUMERATION') {
        <vectronic-parameter-selection-config
          class="parameter-value__item"
          [config]="config()"
          [value]="currentValue()"
          [disabled]="isDisabled()"
          [resetToFactoryTooltip]="resetToFactoryTooltip()"
          (parameterChange)="onParameterChange($event)"
          [readonly]="false"
          [hasClose]="showEditButton()"
          (close)="onClose()"
          [hideLabel]="hideLabel()"
          [showInfo]="showInfo()"
          (parameterUndo)="parameterUndo.emit($event)"
          [hasDelete]="false"
          [hasUndo]="hasUndo()"
          [showReset]="showReset()"
          (resetToFactory)="resetToFactory.emit($event)"
        ></vectronic-parameter-selection-config>
      } @else if (valueType() === 'TIME_SPAN') {
        <vectronic-parameter-timespan-config
          class="parameter-value__item"
          [config]="config()"
          [value]="currentValue()"
          [disabled]="isDisabled()"
          [resetToFactoryTooltip]="resetToFactoryTooltip()"
          (parameterChange)="onParameterChange($event)"
          [readonly]="false"
          [hasClose]="showEditButton()"
          (close)="onClose()"
          [hideLabel]="hideLabel()"
          [showInfo]="showInfo()"
          (parameterUndo)="parameterUndo.emit($event)"
          [hasDelete]="false"
          [hasUndo]="hasUndo()"
          [showReset]="showReset()"
          (resetToFactory)="resetToFactory.emit($event)"
        >
        </vectronic-parameter-timespan-config>
      } @else if (valueType() === 'TIME_ZONE') {
        <vectronic-parameter-timezone-config
          class="parameter-value__item"
          [config]="config()"
          [value]="currentValue()"
          [disabled]="isDisabled()"
          [resetToFactoryTooltip]="resetToFactoryTooltip()"
          (parameterChange)="onParameterChange($event)"
          [readonly]="false"
          [hasClose]="showEditButton()"
          (close)="onClose()"
          [hideLabel]="hideLabel()"
          [showInfo]="showInfo()"
          (parameterUndo)="parameterUndo.emit($event)"
          [hasDelete]="false"
          [hasUndo]="hasUndo()"
          [showReset]="showReset()"
          (resetToFactory)="resetToFactory.emit($event)"
        >
        </vectronic-parameter-timezone-config>
      } @else if (valueType() === 'LIST_UNSIGNED_INT_4') {
        <vectronic-parameter-collars-config
          class="parameter-value__item"
          [config]="config()"
          [userValue]="userValue()"
          [disabled]="isDisabled()"
          [resetToFactoryTooltip]="resetToFactoryTooltip()"
          (parameterChange)="onParameterChange($event)"
          [collarIds]="collarIds()"
          [readonly]="false"
          [hasClose]="showEditButton()"
          (close)="onClose()"
          [hideLabel]="hideLabel()"
          [showInfo]="showInfo()"
          (parameterUndo)="parameterUndo.emit($event)"
          [hasDelete]="false"
          [hasUndo]="hasUndo()"
          [showReset]="showReset()"
          (resetToFactory)="resetToFactory.emit($event)"
          [factoryValue]="factoryValue()"
        >
        </vectronic-parameter-collars-config>
      } @else if (valueType() === 'DAYTIME') {
        <vectronic-parameter-time-config
          class="parameter-value__item"
          [config]="config()"
          [value]="currentValue()"
          [disabled]="isDisabled()"
          [resetToFactoryTooltip]="resetToFactoryTooltip()"
          (parameterChange)="onParameterChange($event)"
          [readonly]="false"
          [hasClose]="showEditButton()"
          (close)="onClose()"
          [hideLabel]="hideLabel()"
          [showInfo]="showInfo()"
          (parameterUndo)="parameterUndo.emit($event)"
          [hasDelete]="false"
          [hasUndo]="hasUndo()"
          [showReset]="showReset()"
          (resetToFactory)="resetToFactory.emit($event)"
        >
        </vectronic-parameter-time-config>
      } @else if (valueType() === 'DATE_TIME') {
        <vectronic-parameter-date-time-config
          class="parameter-value__item"
          [config]="config()"
          [value]="currentValue()"
          [disabled]="isDisabled()"
          [resetToFactoryTooltip]="resetToFactoryTooltip()"
          (parameterChange)="onParameterChange($event)"
          [readonly]="false"
          [hasClose]="showEditButton()"
          (close)="onClose()"
          [hideLabel]="hideLabel()"
          [showInfo]="showInfo()"
          (parameterUndo)="parameterUndo.emit($event)"
          [hasDelete]="false"
          [hasUndo]="hasUndo()"
          [showReset]="showReset()"
          (resetToFactory)="resetToFactory.emit($event)"
        ></vectronic-parameter-date-time-config>
      } @else if (valueType() === 'VHF_PATTERN') {
        <vectronic-parameter-pattern-input-config
          class="parameter-value__item"
          [config]="config()"
          [value]="currentValue()"
          [disabled]="isDisabled()"
          [resetToFactoryTooltip]="resetToFactoryTooltip()"
          (parameterChange)="onParameterChange($event)"
          [readonly]="false"
          [hasClose]="showEditButton()"
          (close)="onClose()"
          [hideLabel]="hideLabel()"
          [showInfo]="showInfo()"
          (parameterUndo)="parameterUndo.emit($event)"
          [hasDelete]="false"
          [hasUndo]="hasUndo()"
          [showReset]="showReset()"
          (resetToFactory)="resetToFactory.emit($event)"
          [patterns]="presetPatternParameter()?.enumCoding"
        ></vectronic-parameter-pattern-input-config>
      } @else if (
        valueType() === 'FLAGS' && parameterWithData().parameter?.name === 'Visibility Flags'
      ) {
        <vectronic-parameter-visibility-flags-config
          class="parameter-value__item"
          [config]="config()"
          [value]="currentValue()"
          [disabled]="isDisabled()"
          [resetToFactoryTooltip]="resetToFactoryTooltip()"
          (parameterChange)="onParameterChange($event)"
          [readonly]="false"
          [hasClose]="showEditButton()"
          (configClose)="onClose()"
          [hideLabel]="hideLabel()"
          [showInfo]="showInfo()"
          (parameterUndo)="parameterUndo.emit($event)"
          [hasDelete]="false"
          [hasUndo]="hasUndo()"
          [showReset]="showReset()"
          (resetToFactory)="resetToFactory.emit($event)"
          [subsystems]="subsystems()"
        ></vectronic-parameter-visibility-flags-config>
      } @else if (valueType()) {
        <vectronic-parameter-input-config
          class="parameter-value__item"
          [config]="config()"
          [value]="currentValue()"
          [disabled]="isDisabled()"
          [resetToFactoryTooltip]="resetToFactoryTooltip()"
          (parameterChange)="onParameterChange($event)"
          [readonly]="false"
          [hasClose]="showEditButton()"
          (close)="onClose()"
          [hideLabel]="hideLabel()"
          [showInfo]="showInfo()"
          (parameterUndo)="parameterUndo.emit($event)"
          [hasDelete]="false"
          [hasUndo]="hasUndo()"
          [showReset]="showReset()"
          (resetToFactory)="resetToFactory.emit($event)"
        ></vectronic-parameter-input-config>
      }
    </div>
    @if (!isValid()) {
      <mat-error class="parameter-value__error">
        {{ errorMessage() }}
      </mat-error>
    }
  }
</div>
